/* Aromahain — molecole 3D reali (coordinate PubChem, solo atomi pesanti) + inclinazione 3D delle schede.
   29/09/2026. Nessuna libreria: canvas 2D con proiezione prospettica. Si attiva solo se in pagina c'e'
   [data-ah-mol] o [data-ah-tilt-root]. Rispetta "riduci movimento" (molecola ferma, niente inclinazione). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var dataPromise = null;

  function loadData(url) {
    if (!dataPromise) dataPromise = fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); });
    return dataPromise;
  }

  var COL = { C: [230, 183, 131], O: [224, 102, 79], N: [120, 170, 230] };
  var RAD = { C: 1, O: 1.12, N: 1.05 };

  function Mol(canvas, mol, opts) {
    this.c = canvas; this.ctx = canvas.getContext('2d'); this.m = mol; this.o = opts || {};
    this.ay = 0.6; this.ax = -0.35; this.vy = reduce ? 0 : 0.0045; this.drag = null; this.visible = false; this.alpha = 0;
    var r = 0; mol.a.forEach(function (p) { r = Math.max(r, Math.sqrt(p[0] * p[0] + p[1] * p[1] + p[2] * p[2])); });
    this.r = r || 1;
    this.resize(); this.bind(); this.frame = this.frame.bind(this);
  }
  Mol.prototype.resize = function () {
    var dpr = Math.min(2, window.devicePixelRatio || 1), w = this.c.clientWidth, h = this.c.clientHeight;
    this.c.width = Math.round(w * dpr); this.c.height = Math.round(h * dpr); this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0); this.w = w; this.h = h;
  };
  Mol.prototype.bind = function () {
    var self = this;
    this.c.addEventListener('pointerdown', function (e) { self.drag = { x: e.clientX, y: e.clientY, ay: self.ay, ax: self.ax }; self.c.setPointerCapture(e.pointerId); });
    this.c.addEventListener('pointermove', function (e) {
      if (!self.drag) return;
      self.ay = self.drag.ay + (e.clientX - self.drag.x) * 0.012;
      self.ax = Math.max(-1.4, Math.min(1.4, self.drag.ax + (e.clientY - self.drag.y) * 0.012));
      if (reduce) self.draw();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { self.c.addEventListener(t, function () { self.drag = null; }); });
    window.addEventListener('resize', function () { self.resize(); self.draw(); });
  };
  Mol.prototype.set = function (mol) { this.m = mol; var r = 0; mol.a.forEach(function (p) { r = Math.max(r, Math.hypot(p[0], p[1], p[2])); }); this.r = r || 1; this.alpha = 0; };
  Mol.prototype.project = function () {
    var cy = Math.cos(this.ay), sy = Math.sin(this.ay), cx = Math.cos(this.ax), sx = Math.sin(this.ax);
    var s = Math.min(this.w, this.h) * 0.47 / this.r, cam = this.r * 3.2, W = this.w / 2, H = this.h / 2;
    return this.m.a.map(function (p) {
      var x = p[0] * cy + p[2] * sy, z = -p[0] * sy + p[2] * cy, y = p[1] * cx - z * sx; z = p[1] * sx + z * cx;
      var k = cam / (cam + z);
      return { x: W + x * s * k, y: H - y * s * k, z: z, k: k, e: p[3] };
    });
  };
  Mol.prototype.draw = function () {
    var ctx = this.ctx, P = this.project(), s = Math.min(this.w, this.h) * 0.47 / this.r, self = this;
    ctx.clearRect(0, 0, this.w, this.h);
    if (this.alpha < 1) this.alpha = Math.min(1, this.alpha + (reduce ? 1 : 0.05));
    ctx.globalAlpha = this.alpha;
    var bonds = this.m.b.slice().sort(function (a, b) { return (P[b[0]].z + P[b[1]].z) - (P[a[0]].z + P[a[1]].z); });
    bonds.forEach(function (b) {
      var A = P[b[0]], B = P[b[1]], depth = (A.k + B.k) / 2, alpha = Math.max(0.25, Math.min(0.9, depth - 0.25));
      ctx.strokeStyle = 'rgba(243,238,228,' + alpha.toFixed(2) + ')'; ctx.lineWidth = 2.2 * depth; ctx.lineCap = 'round';
      if (b[2] >= 2) {
        var dx = B.y - A.y, dy = A.x - B.x, L = Math.hypot(dx, dy) || 1, off = 2.6 * depth; dx = dx / L * off; dy = dy / L * off;
        ctx.beginPath(); ctx.moveTo(A.x + dx, A.y + dy); ctx.lineTo(B.x + dx, B.y + dy); ctx.moveTo(A.x - dx, A.y - dy); ctx.lineTo(B.x - dx, B.y - dy); ctx.stroke();
      } else { ctx.beginPath(); ctx.moveTo(A.x, A.y); ctx.lineTo(B.x, B.y); ctx.stroke(); }
    });
    P.map(function (p, i) { return i; }).sort(function (a, b) { return P[b].z - P[a].z; }).forEach(function (i) {
      var p = P[i], col = COL[p.e] || COL.C, rad = Math.max(3, s * 0.34 * (RAD[p.e] || 1) * p.k);
      var g = ctx.createRadialGradient(p.x - rad * 0.35, p.y - rad * 0.35, rad * 0.1, p.x, p.y, rad);
      g.addColorStop(0, 'rgba(255,248,238,0.95)'); g.addColorStop(0.35, 'rgb(' + col.join(',') + ')'); g.addColorStop(1, 'rgba(' + col.map(function (v) { return Math.round(v * 0.45); }).join(',') + ',1)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, rad, 0, Math.PI * 2); ctx.fill();
    });
    ctx.globalAlpha = 1;
  };
  Mol.prototype.frame = function () {
    if (!this.visible) { this.raf = null; return; }
    if (!this.drag) this.ay += this.vy;
    this.draw(); this.raf = requestAnimationFrame(this.frame);
  };
  Mol.prototype.start = function () { this.visible = true; if (reduce) { this.draw(); return; } if (!this.raf) this.raf = requestAnimationFrame(this.frame); };
  Mol.prototype.stop = function () { this.visible = false; };

  function initMols() {
    var nodes = document.querySelectorAll('[data-ah-mol]');
    if (!nodes.length) return;
    nodes.forEach(function (box) {
      var canvas = box.querySelector('canvas'); if (!canvas) return;
      loadData(box.getAttribute('data-src')).then(function (data) {
        var keys = (box.getAttribute('data-ah-mol') || '').split(',').filter(function (k) { return data[k]; });
        if (!keys.length) return;
        var mol = new Mol(canvas, data[keys[0]]), i = 0, labels = (box.closest('[data-ah-mol-card]') || box).querySelectorAll('[data-ah-mol-i]');
        var card = box.closest('[data-ah-mol-card]') || box.parentNode, m0 = data[keys[0]], bg = (document.documentElement.lang || '').indexOf('bg') === 0;
        var sub = function (f) { return f.replace(/\d/g, function (d) { return '₀₁₂₃₄₅₆₇₈₉'.charAt(+d); }); };
        var n = card.querySelector('[data-ah-mol-name]'), f = card.querySelector('[data-ah-mol-f]'), l = card.querySelector('[data-ah-mol-cid]');
        if (n) n.textContent = bg ? m0.bg : m0.de;
        if (f) f.textContent = sub(m0.f);
        if (l) l.href = 'https://pubchem.ncbi.nlm.nih.gov/compound/' + m0.cid;
        card.querySelectorAll('[data-ah-mol-key]').forEach(function (el) { var d = data[el.getAttribute('data-ah-mol-key')]; if (d) el.textContent = (bg ? d.bg : d.de) + ' · ' + sub(d.f); });
        box.classList.add('is-ready');
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) mol.start(); else mol.stop(); }); }, { threshold: 0.1 }).observe(box);
        } else mol.start();
        if (keys.length > 1 && !reduce) {
          setInterval(function () {
            if (!mol.visible || mol.drag) return;
            i = (i + 1) % keys.length; mol.set(data[keys[i]]);
            labels.forEach(function (l) { l.hidden = +l.getAttribute('data-ah-mol-i') !== i; });
          }, 6500);
        }
      }).catch(function () {});
    });
  }

  function initTilt() {
    if (reduce) return;
    document.querySelectorAll('[data-ah-tilt-root]').forEach(function (root) {
      var cards = root.querySelectorAll('[data-ah-tilt]');
      if (hover) {
        cards.forEach(function (c) {
          c.addEventListener('pointermove', function (e) {
            var r = c.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
            c.style.transform = 'perspective(900px) rotateX(' + (-py * 7).toFixed(2) + 'deg) rotateY(' + (px * 9).toFixed(2) + 'deg) translateZ(0)';
            c.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%'); c.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
            c.classList.add('is-tilt');
          });
          c.addEventListener('pointerleave', function () { c.style.transform = ''; c.classList.remove('is-tilt'); });
        });
      } else {
        var ticking = false;
        var update = function () {
          ticking = false; var vh = window.innerHeight;
          cards.forEach(function (c) {
            var r = c.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
            var p = ((r.top + r.height / 2) - vh / 2) / vh;
            c.style.transform = 'perspective(900px) rotateX(' + (p * 8).toFixed(2) + 'deg)';
            c.style.setProperty('--gy', (50 + p * 80).toFixed(1) + '%');
          });
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
        update();
      }
    });
  }

  function init() { initMols(); initTilt(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
